import { Component } from '@contorion/core';

const SOURCE_BUNDLE_IDENTIFIER: string = '#BUNDLE';

export class ImageComponent extends Component {
    constructor(protected element: HTMLImageElement) {
        super(element);

        element.addEventListener('error', this.onError.bind(this));
    }

    protected showDefaultImage(): void {
        this.element.src = (<any> window).contorion.defaultImage;
    }

    protected onError(): void {
        if (this.element.src.includes(SOURCE_BUNDLE_IDENTIFIER)) {
            return;
        }

        this.showDefaultImage();
    }
}
